import createEmotion from '@emotion/css/create-instance';

// Basically, emotion does not play nicely with SSR if you have two 'instances' of it, which we do (one here, and one in codebase for the main site).
// This is the work around - essentially, creating our own 'instance' of the Emotion bindings, with their own cache (the cache is the important bit).

export const { flush, hydrate, cx, merge, getRegisteredStyles, injectGlobal, keyframes, css, sheet, cache } =
  createEmotion({
    key: 'consumer',
  });
